import { mapGetters } from 'vuex'
import busenaNtrTipas from '@/mixins/busenaNtrTipas'

export default {
  mixins: [busenaNtrTipas],
  computed: {
    ...mapGetters(['prasymasTipas']),
    ntrTooltipPrefix() {
      let prefix = 'NtrPaslaugos.'

      if (this.isPrasymasSeima) {
        prefix += ' Šeima.'
      }
      if (this.isPrasymasBendra) {
        prefix += ' Bendroji.'
      }
      if (this.isPrasymasPirmenybe) {
        prefix += ' Pirmenybė.'
      }
      if (this.isPrasymasNuoma) {
        prefix += ' Nuoma.'
      }
      if (this.isPrasymasPanauda) {
        prefix += ' Panauda.'
      }
      if (this.isPrasymasSubnuoma) {
        prefix += ' Subnuoma.'
      }
      if (this.isPrasymasPreliminari) {
        prefix += ' Preliminari.'
      }

      return prefix
    },
  },
}
